import { IEmployee } from "Dashboard/scenes/HumanResources/domain/IEmployee";
import { hrService } from "Dashboard/scenes/HumanResources/services/hr.services";
import { useOnClickOutside } from "hooks/ClickOutside";
import { useEffect, useRef, useState } from "react";

interface IProps {
  setEmployee: Function;
  setNewFullName: Function;
  clearValue?: Function;
  defaultValue?: string;
  employeeOptions?: IEmployee[];
  classes: string;
  placeholder?: string;
}

const EmployeeSelectCustom = ({
  setEmployee,
  setNewFullName,
  clearValue,
  defaultValue,
  employeeOptions,
  classes,
  placeholder }: IProps) => {

  const [isActive, setIsActive] = useState(false);
  const [options, setOptions] = useState<{ label: string, value: number, show: boolean }[]>([]);

  const [nameForUser, setNameForUser] = useState("");

  const ref = useRef<HTMLInputElement>(null);

  const hideDropdown = () => {
    setIsActive(false);
  };

  useOnClickOutside(ref, hideDropdown);

  const search = (searchBoxValue: string) => {
    const searchTerm = searchBoxValue.toLowerCase();
    setOptions(options.map((opt) =>
      !opt.label.toLowerCase().includes(searchTerm)
        ? { ...opt, show: false }
        : { ...opt, show: true }
    ));
  };

  useEffect(() => {
    async function getData() {
      const employees = await hrService.getAllEmployees();
      const op = employees.map((employee) => {
        return {
          label: employee.employeeName,
          value: employee.employeeId,
          show: true
        };
      });

      setOptions(op);
    }
    try {
      if (employeeOptions) {
        const op = employeeOptions.map((employee) => {
          return {
            label: employee.employeeName,
            value: employee.employeeId,
            show: true
          };
        });
        setOptions(op);
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [employeeOptions]);

  useEffect(() => {
    defaultValue && setNameForUser(defaultValue);
  }, [defaultValue])

  const handleOnChange = (e: any) => {
    const inputVal = e.target.value;
    search(inputVal);
    setNameForUser(inputVal);
    setNewFullName(inputVal);
    setEmployee(null);
  };

  const selectOption = (option: string | null, employeeId: number) => {
    if (option) {
      setNameForUser(option);
      setEmployee(employeeId);
      setNewFullName(null);
      hideDropdown();
    }
  };

  return (
    <div className={classes} ref={ref}>
      <div className="dropdown-btn">
        <input
          type="text"
          spellCheck={false}
          placeholder={placeholder}
          className="dropdown-input"
          onChange={(e) => { handleOnChange(e) }}
          onClick={() => { setIsActive(true); search(""); }}
          value={nameForUser ? nameForUser : ""}
        />
      </div>
      <span
        className={nameForUser ? "show" : "disable"}
        onClick={(e: any) => {
          setNameForUser("");
          search("");
          clearValue && clearValue(e.target.value);
        }}
      > {String.fromCharCode(0x2716)}
      </span>
      <div
        className="dropdown-content"
        style={{ display: isActive ? "block" : "none" }}
      >
        {options.map(o => (
          <div
            key={o.value}
            onClick={(e) => {
              const input = e.target as HTMLElement;
              selectOption(input.textContent, o.value);
            }}
            className={`item ${o.show ? "show" : "disable"}`}
          >
            {o.label}
          </div>
        ))}
      </div>
    </div>
  )
};

export default EmployeeSelectCustom;
